import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import MarkerMaps from './MarkerMaps';
import UsgsLegend from './UsgsLegend';
import PanelHeader from './PanelHeader';
import Error from './Error';
import { getUsgsGwPts } from './routines';

export default function UsgsGroundwater(props) {
	const { mode, gwSaved, setGwSaved } = props;
	const [ panelError, setPanelError ] = useState(false);
	const [ showdm, setShowdm ] = useState(gwSaved["showdm"]);

	const selectedState = "vt";
	const prefix = mode === 'dev' ? "vt/" : "https://nedews.nrcc.cornell.edu/";
    const gwFileName = prefix + "data/wells.json";
	const gwTitle = "Groundwater";
	const buttonValue = null;
	const addtext = " ";
 
	useEffect(() => {
		setGwSaved({...gwSaved, showdm:showdm});
		// eslint-disable-next-line
	}, [showdm]);

	useEffect(() => {
        if (!gwSaved["markers"]) {
			getUsgsGwPts(gwFileName, gwSaved, setGwSaved, setPanelError);
        }
		// eslint-disable-next-line
	}, [])

	return (
		<>
			{!panelError &&
				<PanelHeader
					title={gwTitle+" Summary"}
					buttonValue={buttonValue}
					addtext={addtext}
					showdm={showdm}
					setShowdm={setShowdm}
				/>
			}
			{gwSaved["markers"] && !panelError &&
				<div className="mapandlegend-container">
					<MarkerMaps 
						selectedState={selectedState} 
						markers={gwSaved["markers"]} 
						mapTitle={gwTitle + " Status"}
						geo="county"
						usdmOverlay={showdm} 
						mode={mode}
					/>
					<UsgsLegend 
						mapType={gwTitle.toLowerCase()}
						mapDate={gwSaved["date"]}
						cagType="usdm"
					/>
				</div>
			}
			{!gwSaved["markers"] && !panelError &&
				<>
					<CircularProgress /> 
					<Typography display="inline" sx={{p:1}}>Loading</Typography>
				</>
			}
			{panelError &&
				<Error />

			}
	   </>
	);
}